import { Cell, Row } from "@tanstack/react-table";
import { useEffect, useState } from "react";

import { useTableContext } from "../../context";

export default function CellInput<T>({
  row,
  cell,
}: {
  row: Row<T>;
  cell: Cell<T, unknown>;
}) {
  const { table } = useTableContext();

  const updateData = table?.options?.meta?.updateData;
  const isUpdating = table?.options?.meta?.isUpdating ?? false;
  const columnId = cell.column?.id;
  const cellValue = cell.getValue() as string | number | undefined;

  const [value, setValue] = useState(cellValue);

  useEffect(() => {
    setValue(cellValue);
  }, [cellValue]);

  return (
    <input
      value={value}
      onChange={(event) => {
        const newValue = event.target.value;
        setValue(newValue);
      }}
      disabled={isUpdating}
      onBlur={(event) => {
        const newValue = event.target.value;
        if (newValue === cellValue) return;
        try {
          updateData?.(row, columnId, newValue);
        } catch (error) {
          console.error(error);
          setValue(cellValue);
        }
      }}
      className="w-full px-2 py-1 border border-gray-300 rounded-sm focus:outline-none focus:ring-1 focus:ring-primary-500 focus:border-primary-500 disabled:bg-gray-100 disabled:cursor-not-allowed"
    />
  );
}
